import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["playButton", "pauseButton"];
  private isPlaying = true;

  declare readonly playButtonTarget: HTMLElement;
  declare readonly pauseButtonTarget: HTMLElement;

  connect(): void {
    this.updateButtonVisibility();
  }

  play(): void {
    if (!this.isPlaying) {
      this.isPlaying = true;
      this.updateButtonVisibility();
      this.dispatch("play", { bubbles: true });
    }
  }

  pause(): void {
    if (this.isPlaying) {
      this.isPlaying = false;
      this.updateButtonVisibility();
      this.dispatch("pause", { bubbles: true });
    }
  }

  private updateButtonVisibility(): void {
    this.playButtonTarget.classList.toggle("hidden", this.isPlaying);
    this.pauseButtonTarget.classList.toggle("hidden", !this.isPlaying);
  }
}
